import { GeneralValueObject } from './general-value-object';

export const Spruce = 'spruce';
export const Pine = 'pine';

export class ForestCompartmentType extends GeneralValueObject {
}

export const ForestCompartmentTypes = [new ForestCompartmentType(Spruce, 'Kuusi'), new ForestCompartmentType(Pine, 'Mänty')];
